import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LandingModel } from '../model/landingModel';

declare var window: any;

@Injectable({providedIn: 'root'})
export class FormsService {
    landingModel: LandingModel;

    constructor(private httpClient: HttpClient) {

    }

    submit(formData: any, type: string) {
        return new Promise((resolve, reject) => {
            let body = this.getCommonBody();
            body['type'] = type;
            body['form_data'] = formData;

            this.httpClient.post('/nymeria-gui/data/model/forms/submit', body)
                .subscribe(response => resolve(response), error => reject(error));
        });
    }

    private getCommonBody() {
        const upaData = window.upaData;
        return {
            cc: upaData.cc,
            ch: upaData.ch,
            lname: upaData.lname,
            ltype: upaData.ltype,
            userid: upaData.userid
        }
    }
}
